import * as React from 'react';

import {Button} from '../button/button';
import {LinkedEntity} from '../linked-entity/linked-entity';

import type {Entity} from './email-sequence-progression';
import {getSendTimestamp} from './helpers';

import styles from './sequence-progression.module.css';

type Props = {
    editionId: string | null | undefined;
    name: string;
    sendTime: number;
    entityType: 'company' | 'lead' | 'person';
    entity: Entity;
    showPreviewModal: (arg1: string, arg2: string) => void;
};

export function ScheduledDetail(props: Props) {
    return (
        <div className={styles.detail}>
            {getScheduledString(props.entity, props.entityType)}
            <Button
                variant='text-primary'
                isFullWidth={false}
                size='small'
                onClick={() => {
                    if (props.editionId) {
                        props.showPreviewModal(props.editionId, props.entity.id);
                    }
                }}
            >
                {props.name}
            </Button>
            {getSendTimestamp(props.sendTime)}
        </div>
    );
}

// @ts-expect-error
function getScheduledString(entity: Entity, entityType) {
    if (entityType === 'person') {
        return 'Scheduled to receive';
    }

    return (
        <>
            <LinkedEntity
                name={entity.name}
                type='contacts'
                htmlUrl={entity.htmlUrl}
                isLinkable={true}
                useEntityColor={true}
            />
            &nbsp;is scheduled to receive
        </>
    );
}
